export const solutionsEs = {
  solutionsPages: {
    common: {
      requestDemo: "Solicitar Demo",
      talkToSales: "Hablar con Ventas",
      backToSolutions: "← Volver a Soluciones",
      keyFeatures: "Funcionalidades Clave",
      whatYouGet: "Qué Incluye",
      howItWorks: "Cómo Funciona",
      readyToStart: "¿Listo para empezar?",
      contactUs: "Contáctanos",
    },
    index: {
      title: "Soluciones para cooperativas, aseguradoras y grandes operaciones",
      subtitle: "Un dataset auditable por parcela — integrado en los flujos de trabajo que tu equipo ya utiliza.",
      learnMore: "Saber más",
    },
    insurance: {
      badge: "Para Aseguradoras",
      title: "Monitoreo de campo y evidencia para seguros paramétricos",
      subtitle: "Monitoreo continuo Sentinel-2 de cada parcela asegurada, con histórico auditable de NDVI / NDWI / ET₀ y anclaje SHA-256 + Polygon. Diseñado para suscripción, siniestros y reporting de reaseguro.",
      cardTitle: "Aseguradoras",
      cardDesc: "Datos auditables de NDVI, ET₀ y riesgo para productos paramétricos y siniestros más rápidos basados en evidencia.",
      features: {
        monitoring: {
          title: "Monitoreo continuo de parcelas",
          desc: "NDVI, NDWI, EVI y NDRE actualizados cada 5 días desde Sentinel-2, con series temporales libres de nubes para cada parcela asegurada.",
        },
        triggers: {
          title: "Disparadores paramétricos configurables",
          desc: "Umbrales de sequía (NDVI / NDWI), helada, estrés térmico y exposición a fuego definidos por cultivo y región.",
        },
        audit: {
          title: "Trazabilidad de evidencia auditable",
          desc: "Cada valor de índice se hashea (SHA-256) y se ancla en Polygon, generando evidencia válida en juicio sin edición manual.",
        },
        api: {
          title: "REST API + webhooks",
          desc: "Envía índices y alertas a nivel parcela directamente a tu sistema de gestión de siniestros. OpenAPI documentado.",
        },
        risk: {
          title: "Scoring de riesgo por parcela",
          desc: "Sentinel Score compuesto (0–100) y detección de anomalías históricas para suscripción de cartera.",
        },
        reports: {
          title: "Informes PDF para siniestros",
          desc: "Informes de evento de pérdida con un clic: imágenes satelitales, índices, contexto meteorológico y prueba blockchain.",
        },
      },
    },
    cooperatives: {
      badge: "Para Cooperativas",
      title: "Operación multi-socio, una sola cabina compartida",
      subtitle: "Agrega las parcelas de todos los socios en un único dashboard. Benchmarking anónimo, reporting PAC / eco-esquemas y herramientas de asesoría compartida — sin renunciar a la soberanía del dato.",
      cardTitle: "Cooperativas",
      cardDesc: "Dashboard de cartera multi-socio, benchmarking anónimo e informes PAC y eco-esquemas con 1 clic.",
      features: {
        portfolio: {
          title: "Dashboard de cartera multi-socio",
          desc: "Agrega cientos de parcelas de todos los socios con acceso por roles para gerentes y agrónomos.",
        },
        benchmarking: {
          title: "Benchmarking anónimo",
          desc: "Compara el rendimiento entre socios (cosecha, uso de agua, NDVI) de forma anónima — fomenta buenas prácticas sin exponer datos.",
        },
        cap: {
          title: "Informes PAC y eco-esquemas",
          desc: "Informes PDF con 1 clic alineados con PAC/MAPA (RD 1054/2022) y los requisitos de eco-esquemas UE.",
        },
        advisory: {
          title: "Herramientas de asesoría compartidas",
          desc: "Los agrónomos de la cooperativa pueden emitir recomendaciones de riego, fertilización y plagas a cualquier parcela de socio.",
        },
        alerts: {
          title: "Alertas colectivas",
          desc: "Alertas de helada, sequía, fuego y plagas enviadas a los socios afectados por email y push.",
        },
        notebook: {
          title: "Cuaderno de campo digital",
          desc: "Trazabilidad PAC de tratamientos, riego y eventos de cosecha para cada socio.",
        },
      },
    },
    largeScale: {
      badge: "Para Grandes Productores · 200+ ha",
      title: "Agricultura de precisión sub-parcela a escala enterprise",
      subtitle: "Suite completa de índices Sentinel-2, motor de riego FAO-56 Dual Kc y zonificación K-Means++ para prescripciones VRI / VRA. Diseñado para operaciones de 200+ hectáreas.",
      cardTitle: "Grandes Productores (200+ ha)",
      cardDesc: "Suite completa Sentinel-2, optimizador de riego FAO-56 Dual Kc y zonificación sub-parcela (VRI / VRA).",
      features: {
        indices: {
          title: "10+ índices de vegetación",
          desc: "NDVI, NDWI, EVI, NDRE, SAVI, NDMI, GNDVI, clorofila y más — con meta-índice fenológico por etapa de cultivo.",
        },
        fao56: {
          title: "Riego FAO-56 Dual Kc",
          desc: "ET₀ Penman-Monteith validado (R²=0.878) con balance hídrico Dual Kc para prescripciones diarias de riego.",
        },
        zonification: {
          title: "Zonificación sub-parcela (K-Means++)",
          desc: "Zonificación automática con cobertura 100% del polígono. Exporta prescripciones VRI / VRA como Shapefile / GeoJSON.",
        },
        sar: {
          title: "Humedad de suelo Sentinel-1 SAR",
          desc: "Backscatter VV/VH real de Sentinel-1 — funciona a través de nubes, sin fallback simulado.",
        },
        yield: {
          title: "Predicción de cosecha con ML",
          desc: "Modelos de cosecha por cultivo calibrados con datos históricos FAOSTAT y ESYRCE.",
        },
        export: {
          title: "Informes PDF + export CSV / GeoJSON",
          desc: "Informes PDF editoriales más exportación de datos crudos para ERP y software de gestión agrícola.",
        },
      },
    },
    agribusiness: {
      badge: "Para Agribusiness y Enterprise",
      title: "Integración API-first para traders, proveedores y plataformas",
      subtitle: "REST API, webhooks y conectores ERP para embeber datos de Sentinel Crop dentro de tus sistemas. Programas piloto disponibles para traders, proveedores de insumos y plataformas agrícolas enterprise.",
      cardTitle: "Agribusiness y Enterprise",
      cardDesc: "Integración API-first para traders, proveedores de insumos y plataformas enterprise — programas piloto disponibles.",
      features: {
        api: {
          title: "REST API documentada",
          desc: "Índices, clima, alertas y certificaciones a nivel parcela vía OpenAPI. Claves sandbox + producción.",
        },
        webhooks: {
          title: "Webhooks genéricos",
          desc: "Envía eventos (alertas, breaches de umbral, certificaciones) a cualquier endpoint HTTPS con firma HMAC.",
        },
        erp: {
          title: "Conectores ERP / siniestros",
          desc: "Patrones de integración directa para SAP, Microsoft Dynamics y las principales plataformas de siniestros.",
        },
        sla: {
          title: "SLA 99,9% de uptime",
          desc: "SLA enterprise con respuesta a incidentes críticos en 24h e ingeniería de cuenta dedicada.",
        },
        whitelabel: {
          title: "Opción white-label",
          desc: "Embebe dashboards e informes bajo tu propia marca para tus clientes downstream.",
        },
        pilots: {
          title: "Programas piloto",
          desc: "Pilotos estructurados de 90 días para traders, proveedores de insumos y plataformas — con métricas de éxito definidas desde el inicio.",
        },
      },
    },
  },
};